var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcForkKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4004 3.00156H29.9004V44.9816H32.9004V29.9816H37.4004C38.2004 29.9816 38.9604 29.6616 39.5204 29.1016C40.0804 28.5416 40.4004 27.7816 40.4004 26.9816V11.9816C40.4404 10.7816 40.2404 9.60156 39.8004 8.48156C39.3604 7.36156 38.7004 6.36156 37.8604 5.52156C37.0204 4.68156 36.0004 4.02156 34.9004 3.58156C33.7804 3.14156 32.6004 2.94156 31.4004 2.98156V3.00156ZM37.3804 27.0016H32.8804V6.14156C37.2004 6.98156 37.3804 11.4416 37.3804 12.0016V27.0016Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 3.00159H11.9004V20.3816H14.9004V3.00159Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3804 3.00159H19.3804V22.5016H7.40039V3.00159H4.40039V22.5016C4.40039 24.1616 5.74039 25.5016 7.40039 25.5016H11.9004V45.0016H14.9004V25.5016H19.3804C21.0404 25.5016 22.3804 24.1616 22.3804 22.5016V3.00159Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForkKnife);
export default __webpack_public_path__ + "static/media/ic-fork-knife.21590e9862253561c8a4fa92732b8dfd.svg";
export { ForwardRef as ReactComponent };